import { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "../../context";
import DateRangePicker from "../../components/Calendar/DateRangePicker";
import ErrorModal from "../../components/ErrorModal/ErrorModal";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import {
  getProductPriceForDateRange,
  getNumberAvailable,
} from "../../library/products";
import moment from "moment";
import {
  adultSelectOptions,
  childrenSelectOptions,
  LODGE_DEFAULTS,
  roomSelectOptions,
} from "./lodgeConstants";
import { FIELD_WIDTH, FIELD_WIDTHS } from "../../config/layoutConfig";
import { searchRooms } from "./searchRooms";

const RoomFilter = ({ rooms, setProducts, store }) => {
  let info = useContext(AppContext);
  const location = useLocation();
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  // set info.lodge values from URL params or if those don't exist, from standard values
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const adults = parseInt(params.get("adults") || LODGE_DEFAULTS.ADULTS);
    const children = parseInt(
      params.get("children") || LODGE_DEFAULTS.CHILDREN
    );
    const checkIn = params.get("check-in")
      ? moment(params.get("check-in"))
      : LODGE_DEFAULTS.CHECK_IN;
    const checkOut = params.get("check-out")
      ? moment(params.get("check-out"))
      : LODGE_DEFAULTS.CHECK_OUT;
    info.setLodge({
      ...info.lodge,
      adults,
      children,
      checkIn,
      checkOut,
    });
  }, []);

  useEffect(() => {
    (async () => {
      const rooms = await searchRooms(store.id, info);
      setProducts(rooms);
    })();
  }, [info.lodge]);

  // const search = async () => {
  //   if (!info.lodge?.checkIn || !info.lodge?.checkOut) {
  //     setIsErrorVisible(true);
  //     return;
  //   }

  //   const rooms = await roomsFromLodge(store.id);

  //   const unavailableRooms = [
  //     ...(await unavailableRoomsDueToDateAndQuantity(store.id, info)),
  //     ...(await unavailableRoomsDueToCapacity(store.id, info)),
  //   ];

  //   // set isAvailable to true for all rooms
  //   const roomList = [...rooms];

  //   for (const room of roomList) {
  //     room.status = "available";
  //   }

  //   // set isAvailable to false for all rooms not available
  //   for (const room of unavailableRooms) {
  //     roomList.find((r) => r.id === room.id).status = "not-available";
  //   }

  //   // sort function
  //   function compare(a, b) {
  //     if (a.status === "available" && b.status === "not-available") {
  //       return -1;
  //     }
  //     return 0;
  //   }

  //   // sort list of rooms
  //   roomList.sort(compare);

  //   for (const room of roomList) {
  //     if (room.status === "available") {
  //       const totalPrice = await getProductPriceForDateRange(
  //         room.id,
  //         room.gen_price,
  //         info.lodge.checkIn,
  //         info.lodge.checkOut
  //       );
  //       room.gen_price = totalPrice * info.lodge.rooms;

  //       const numberAvailable = await getNumberAvailable(
  //         room.id,
  //         info.lodge.checkIn,
  //         info.lodge.checkOut
  //       );
  //       room.available_quantity = numberAvailable;
  //     }
  //   }

  //   setProducts(roomList);
  // };

  return (
    <>
      <div className="ahp-filter">
        <DateRangePicker dates={[info.lodge.checkIn, info.lodge.checkOut]} />

        <div>
          <div style={{ display: "inline", marginTop: 6 }}>
            {info.t("adults")}:
          </div>
          <AHPSelect
            label={info.t("adults")}
            type="lodge"
            field="adults"
            width={FIELD_WIDTHS.XS}
            options={adultSelectOptions}
            defaultValue={2}
          />
        </div>

        <div>
          <div style={{ display: "inline", marginTop: 6 }}>
            {info.t("children")}:
          </div>
          <AHPSelect
            label={info.t("children")}
            type="lodge"
            field="children"
            options={childrenSelectOptions}
            defaultValue={0}
            width={FIELD_WIDTHS.XS}
          />
        </div>

        <div>
          <div style={{ display: "inline", marginTop: 6 }}>
            {info.t("rooms")}:
          </div>
          <AHPSelect
            label={info.t("rooms")}
            type="lodge"
            field="rooms"
            width={FIELD_WIDTHS.XS}
            options={roomSelectOptions}
            defaultValue={1}
          />
        </div>

        {/* <button className="search-btn" type="button" onClick={search}>
          Pesquisar
        </button> */}
      </div>

      <ErrorModal
        text={info.t("setDates")}
        isErrorVisible={isErrorVisible}
        setIsErrorVisible={setIsErrorVisible}
      />
    </>
  );
};

export default RoomFilter;
